import React from "react";

import jsPDF from "jspdf";

class Module2PDFGenerator extends React.Component {
  genertatePDF(pdfInfo_Age, pdfInfo_Answer) {
    var doc = new jsPDF("p", "pt");
    var width = doc.internal.pageSize.width;
    var height = doc.internal.pageSize.height;

    var data = require("./pdfData.json");

    //Page1
    doc.addImage(data[0].page1, "png", 0, 0, width, height);
    doc.text(doc.splitTextToSize(70 - Number(pdfInfo_Age) + "", 470), 140, 658);

    //Page2
    doc.addPage();
    doc.addImage(data[1].page2, 0, 0, width, height);

    //Page3
    doc.addPage();
    doc.addImage(data[2].page3, 0, 0, width, height);

    //Page4
    doc.addPage();
    doc.addImage(data[3].page4, 0, 0, width, height);
    doc.setFontSize(11);
    doc.text(doc.splitTextToSize(pdfInfo_Answer, 470), 71, 129);

    //Page5
    doc.addPage();
    doc.addImage(data[4].page5, 0, 0, width, height);

    doc.save("I have some ideas and want to focus my thinking.pdf");
  }

  render() {
    return <div></div>;
  }
}

export default Module2PDFGenerator;
